import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppRedirectPaths } from '@web-config-app/core-react';

/**
 * Redirects to the landing page if a landingRedirectPath resolves to a string.
 * Computes the path internally so it has access to route params (e.g. tenantId).
 */

export function LandingRedirect() {
  const { landingRedirectPath } = useAppRedirectPaths();
  const path = landingRedirectPath();

  return path ? <Navigate to={path} replace /> : null;
}
